import { Button, Col, Collapse, message, Row, Spin, Table, Typography } from "antd";
import Axios from "axios";
import React, { useEffect } from "react";

const { Panel } = Collapse;

const verifDataBotsStyles = `
.row-added {
    background-color: #d4edda;
}

.row-modified {
    background-color: #fff3cd;
}

.row-deleted {
    background-color: #f8d7da;
}

.ant-table-tbody > tr.ant-table-row:hover > td, .ant-table-body > tr > td.ant-table-cell-row-hover {
    background: none !important;
}

.ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table > tbody > tr > td {
    border-right: none;
}

.ant-table-tbody > tr > td {
    border-bottom: 1px solid rgb(209, 209, 209);
}

.siretisation-snackbar .ant-message-notice-content {
    font-size: 16px;
    padding: 14px 22px;
}
`;

interface Enseigne {
    enseigne: string;
    lines: LineData[];
}

interface LineData {
    id: number;
    raison_sociale: string;
    address_full: string | null;
    phone: string | null;
    email: string | null;
    website: string | null;
    siret: string | null;
    enseigne: string | null;
    comment: string | null;
    status: "modified" | "deleted" | "added" | "updated" | null;
    reference_id: number | null;
    prod: boolean,
    previousVersion: LineData | null;
    processing_status: string | null;
}

export function VerifDataBots() {
    const [dataToVerify, setDataToVerify] = React.useState<Enseigne[] | null>(null);

    useEffect(() => {
        Axios.get('/ms/bots/getLinesToVerify')
            .then((response) => {
                console.log(response.data);
                setDataToVerify(response.data);
            })
            .catch((error) => {
                console.error('Erreur lors du chargement des données', error);
            });
    }, []);

    const buildUpdatedLines = (line: LineData): LineData[] => {
        const updatedLine = line;
        const previousVersionLine = line.previousVersion;
        switch (line.status) {
            case 'added':
                updatedLine.processing_status = "siretisation_pending";
                break;
            case 'modified':
                updatedLine.processing_status = "siretisation_pending";
                if (previousVersionLine) {
                    previousVersionLine.processing_status = "archived";
                    previousVersionLine.prod = false;
                }
                break;
            case 'deleted':
                updatedLine.processing_status = "archived";
                updatedLine.prod = false;
                break;
            default:
                break;
        }
        return previousVersionLine != null ? [updatedLine, previousVersionLine] : [updatedLine];
    };

    const notifySiretisationIfEmpty = (remainingLines: number, enseigne: string) => {
        if (remainingLines === 0) {
            message.open({
                type: 'success',
                duration: 5,
                className: 'siretisation-snackbar',
                content: "Lancement automatique de la siretisation, un webhook vous informera de la fin du processus",
            });
            Axios.post('/ms/bots/prefect/' + enseigne + '/siretization');
        }
    };

    const handleUpdateSingleLine = (enseigne: string, line: LineData) => {
        const previousVersionLine = line.previousVersion;
        console.log("line", line, "\n previousVersionLine", previousVersionLine);
        const updatedLines = buildUpdatedLines(line);
        console.log("updatedLines", updatedLines);
        updateMultipleLines(updatedLines).then((success) => {
            if (success) {
                const remainingLines = (dataToVerify ?? []).reduce((count, s) => {
                    const kept = s.enseigne === enseigne
                        ? s.lines.filter((l) => l.id !== line.id)
                        : s.lines;
                    return count + kept.length;
                }, 0);
                notifySiretisationIfEmpty(remainingLines, enseigne);
                // Remove the line from the list of lines to verify
                setDataToVerify((prevData) =>
                    prevData ? prevData.map((s) =>
                        s.enseigne === enseigne
                                        ? {
                                            ...s,
                                            lines: s.lines.filter((l) => l.id !== line.id),
                                        }
                                        : s
                    )
                        : null
                );
            }
        });
    };

    const handleUpdateLinesOfSign = (enseigne: string, lines: LineData[]) => {
        const updatedLines = lines.flatMap(buildUpdatedLines);

        console.log("updatedLines", updatedLines);
        updateMultipleLines(updatedLines).then((success) => {
            if (success) {
                const remainingLines = (dataToVerify ?? []).reduce((count, item) => {
                    return count + item.lines.filter((s) => s.enseigne !== enseigne).length;
                }, 0);
                notifySiretisationIfEmpty(remainingLines, enseigne);
                // Remove the lines from the list of lines to verify
                setDataToVerify((prevData) =>
                    prevData ? prevData.map((item) => {
                        return {
                            ...item,
                            lines: item.lines.filter((s) => s.enseigne !== enseigne),
                        }
                    }) : null
                );
            }
        });
    };

    const updateMultipleLines = async (updatedLines: LineData[]): Promise<boolean> => {
        try {
            await Axios.post('/ms/bots/updateLines', {
                updatedLines: JSON.stringify(updatedLines)
            });
            console.log('Lines updated successfully');
            return true;
        } catch (error) {
            console.error('Error while updating the line', error);
            return false;
        }
    };

    const countLinesPerStatus = (lines: LineData[], status: string) => {
        return lines.filter((line) => line.status === status).length;
    }

    return (
        <div style={dataToVerify == null || dataToVerify.length === 0 ? { textAlign: 'center', marginTop: '50px' } : {}}>
            <style>{verifDataBotsStyles}</style>
            {dataToVerify == null ? (
                <Spin size="large" tip="Chargement" />
            ) : dataToVerify.length === 0 ? (
                <Typography.Text type="secondary">✅ Aucune donnée à valider</Typography.Text>
            ) : (


                        <Collapse>
                            {dataToVerify.map((line, signIndex) => {
                                const panelHeader = (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', width: '100%' }}>
                                        <span>{line.enseigne}</span>
                                        <Typography.Text type="secondary">
                                            {countLinesPerStatus(line.lines, 'added')} ajoutées
                                        </Typography.Text>
                                        <Typography.Text type="secondary">
                                            {countLinesPerStatus(line.lines, 'modified')} modifiées
                                        </Typography.Text>
                                        <Typography.Text type="secondary">
                                            {countLinesPerStatus(line.lines, 'deleted')} supprimées
                                        </Typography.Text>
                                        <Button
                                            type="primary"
                                            disabled={line.lines.length === 0}
                                            style={{ borderRadius: '10px' }}
                                            onClick={() => handleUpdateLinesOfSign(line.enseigne, line.lines)}
                                        >
                                            Valider
                                        </Button>
                                    </div>
                                );
                                return (
                                    <Panel header={panelHeader} key={`${line.enseigne}-${signIndex}`}>
                                        {line.lines.length === 0 ?
                                            <Typography.Text type="secondary">Aucune donnée à valider</Typography.Text>
                                            :
                                            <Table
                                                dataSource={line.lines}
                                                bordered={true}
                                                rowKey="id"
                                                pagination={false}
                                                className="custom-table-row"
                                                rowClassName={(line) => {
                                                    switch (line.status) {
                                                        case 'added':
                                                            return 'row-added';
                                                        case 'modified':
                                                            return 'row-modified';
                                                        case 'deleted':
                                                            return 'row-deleted';
                                                        default:
                                                            return '';
                                                    }
                                                }}
                                            >
                                                <Table.Column
                                                    title="Siret"
                                                    dataIndex="siret"
                                                    key="siret"
                                                    render={(text, line: LineData) => (
                                                        <>
                                                            {text}
                                                            {line.previousVersion && (
                                                                <>
                                                                    <br />
                                                                    <Typography.Text delete type="secondary">
                                                                        {line.previousVersion.siret}
                                                                    </Typography.Text>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                />
                                                <Table.Column
                                                    title="Raison sociale"
                                                    dataIndex="raison_sociale"
                                                    key="raison_sociale"
                                                    render={(text, line: LineData) => (
                                                        <>
                                                            {text}
                                                            {line.previousVersion && (
                                                                <>
                                                                    <br />
                                                                    <Typography.Text delete type="secondary">
                                                                        {line.previousVersion.raison_sociale}
                                                                    </Typography.Text>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                />
                                                <Table.Column
                                                    title="Adresse"
                                                    dataIndex="address_full"
                                                    key="address_full"
                                                    render={(text, line: LineData) => (
                                                        <>
                                                            {text}
                                                            {line.previousVersion && (
                                                                <>
                                                                    <br />
                                                                    <Typography.Text delete type="secondary">
                                                                        {line.previousVersion.address_full}
                                                                    </Typography.Text>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                />
                                                <Table.Column
                                                    title="Tel"
                                                    dataIndex="phone"
                                                    key="phone"
                                                    render={(text, line: LineData) => (
                                                        <>
                                                            {text}
                                                            {line.previousVersion && (
                                                                <>
                                                                    <br />
                                                                    <Typography.Text delete type="secondary">
                                                                        {line.previousVersion.phone}
                                                                    </Typography.Text>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                />
                                                <Table.Column
                                                    title="Email"
                                                    dataIndex="email"
                                                    key="email"
                                                    render={(text, line: LineData) => (
                                                        <>
                                                            {text}
                                                            {line.previousVersion && (
                                                                <>
                                                                    <br />
                                                                    <Typography.Text delete type="secondary">
                                                                        {line.previousVersion.email}
                                                                    </Typography.Text>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                />
                                                <Table.Column
                                                    title="Site web"
                                                    dataIndex="website"
                                                    key="website"
                                                    render={(text, line: LineData) => (
                                                        <>
                                                            {text}
                                                            {line.previousVersion && (
                                                                <>
                                                                    <br />
                                                                    <Typography.Text delete type="secondary">
                                                                        {line.previousVersion.website}
                                                                    </Typography.Text>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                />
                                                <Table.Column
                                                    title="Commentaire"
                                                    dataIndex="comment"
                                                    key="comment"
                                                    render={(text, line: LineData) => (
                                                        <>
                                                            {text}
                                                            {line.previousVersion && (
                                                                <>
                                                                    <br />
                                                                    <Typography.Text delete type="secondary">
                                                                        {line.previousVersion.comment}
                                                                    </Typography.Text>
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                />
                                                <Table.Column
                                                    title=""
                                                    key="action"
                                                    render={(text, line: LineData) => <Button type="primary" onClick={() => handleUpdateSingleLine(line.enseigne ?? '', line)}>Valider</Button>}
                                                />
                                            </Table>
                                        }
                                    </Panel>);
                            })}
                        </Collapse>
                )}
        </div>
    );
}
